const logoDark = require('../assets/images/logo-dark.png');
const logo = require('../assets/images/logo.png');
const noData = require('../assets/images/no-data.svg');

export const IMAGES = {
  LOGO_DARK: logoDark,
  LOGO: logo,
  NO_DATA: noData,
};
